var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2Img(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 282,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22492_9870)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22492_9870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 30.8496C20.8501 25.3268 25.3273 20.8496 30.8501 20.8496H403.85V269.8H20.8501V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8501,
    y: 20.8486,
    width: 383.921,
    height: 24.8582,
    fill: "#CEDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2202 36.5906C88.2202 32.0532 91.8985 28.375 96.4358 28.375H157.341C161.878 28.375 165.557 32.0532 165.557 36.5906V48.6298H88.2202V36.5906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2342,
    y: 54.2337,
    width: 347.232,
    height: 17.2318,
    rx: 8.61592,
    stroke: "#CDCDCD",
    strokeWidth: 0.768158
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3789 37.8243C36.6215 38.3303 35.7326 38.6003 34.8218 38.6003C33.6012 38.6003 32.4302 38.1153 31.5668 37.252C30.7034 36.3888 30.2183 35.2179 30.2183 33.9968C30.2183 33.0861 30.4883 32.1965 30.9944 31.4393C31.5006 30.6821 32.2196 30.0925 33.0604 29.7436C33.9012 29.3955 34.8271 29.3045 35.7198 29.482C36.6125 29.6594 37.433 30.0978 38.0768 30.7415C38.7206 31.3852 39.1591 32.2056 39.3366 33.0989C39.5141 33.9922 39.4231 34.9172 39.0749 35.7586C38.7266 36.6001 38.1362 37.3182 37.3789 37.8243Z",
    fill: "#FF6058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.189 37.8243C50.4324 38.3303 49.5419 38.6003 48.6319 38.6003C48.0272 38.6003 47.4293 38.4815 46.8705 38.2499C46.3124 38.0183 45.804 37.6791 45.3768 37.252C44.9496 36.8249 44.6104 36.3174 44.3788 35.7587C44.1472 35.2 44.0283 34.6014 44.0283 33.9968C44.0283 33.0862 44.2983 32.1967 44.8045 31.4394C45.3106 30.6822 46.0289 30.092 46.8705 29.7438C47.7113 29.3949 48.6371 29.3047 49.5298 29.4821C50.4226 29.6596 51.2431 30.098 51.8869 30.7416C52.5307 31.3853 52.9691 32.2064 53.1466 33.099C53.3241 33.9923 53.2331 34.9165 52.8849 35.7579C52.5367 36.5993 51.9463 37.3182 51.189 37.8243Z",
    fill: "#FFBD2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9998 37.8243C64.2432 38.3303 63.3534 38.6003 62.4427 38.6003C61.838 38.6003 61.2393 38.4815 60.6805 38.2499C60.1217 38.0183 59.6141 37.6791 59.1869 37.252C58.7597 36.8249 58.4205 36.3173 58.1889 35.7586C57.9572 35.1999 57.8384 34.6013 57.8384 33.9968C57.8384 33.0861 58.1084 32.1965 58.6145 31.4393C59.1207 30.6821 59.8397 30.0918 60.6805 29.7436C61.5214 29.3955 62.4472 29.3045 63.3399 29.482C64.2326 29.6594 65.0532 30.0978 65.6969 30.7415C66.3407 31.3852 66.7792 32.2056 66.9567 33.0982C67.1342 33.9915 67.0432 34.9164 66.695 35.7579C66.3468 36.5993 65.7571 37.3182 64.9998 37.8243Z",
    fill: "#27C940"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22492_9870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.847 59.5559C390.414 59.5559 390.874 59.0961 390.874 58.5289C390.874 57.9617 390.414 57.502 389.847 57.502C389.28 57.502 388.82 57.9617 388.82 58.5289C388.82 59.0961 389.28 59.5559 389.847 59.5559Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.847 63.6633C390.414 63.6633 390.874 63.2035 390.874 62.6363C390.874 62.0692 390.414 61.6094 389.847 61.6094C389.28 61.6094 388.82 62.0692 388.82 62.6363C388.82 63.2035 389.28 63.6633 389.847 63.6633Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.847 67.7717C390.414 67.7717 390.874 67.3119 390.874 66.7447C390.874 66.1776 390.414 65.7178 389.847 65.7178C389.28 65.7178 388.82 66.1776 388.82 66.7447C388.82 67.3119 389.28 67.7717 389.847 67.7717Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 112.158,
    y: 35.8389,
    width: 46.0337,
    height: 4.60337,
    rx: 2.30168,
    fill: "#EEECF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.4272,
    y: 33.9971,
    width: 8.77895,
    height: 8.77895,
    rx: 1.09737,
    fill: "#EEECF2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 317.89,
    height: 187.67,
    transform: "translate(86.4604 98.9873)",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 236.694,
    height: 140.178,
    transform: "translate(127.058 113.188)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.125,
    y: 144.103,
    width: 158.562,
    height: 41.786,
    stroke: "#C9C9C9",
    strokeWidth: 0.766,
    strokeLinecap: "round",
    strokeDasharray: "1.53 1.53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.125,
    y: 189.153,
    width: 158.562,
    height: 33.2982,
    stroke: "#C9C9C9",
    strokeWidth: 0.766,
    strokeLinecap: "round",
    strokeDasharray: "1.53 1.53"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_22492_9870",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3501 77.8496H86.4601V298.458H21.3501V77.8496Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.3501 77.8496H86.4601V298.458H21.3501V77.8496Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4601 77.8496H85.6941V298.458H86.4601H87.2261V77.8496H86.4601Z",
    fill: "#ECECEC",
    mask: "url(#path-15-inside-1_22492_9870)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.6911,
    y: 120.362,
    width: 44.428,
    height: 31.406,
    rx: 3.447,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.6911,
    y: 120.362,
    width: 44.428,
    height: 31.406,
    rx: 3.447,
    stroke: "#AB8B7D",
    strokeWidth: 0.766
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3081 162.875C31.3081 160.76 33.0229 159.045 35.1381 159.045H72.6721C74.7874 159.045 76.5021 160.76 76.5021 162.875V187.387C76.5021 189.502 74.7874 191.217 72.6721 191.217H35.1381C33.0229 191.217 31.3081 189.502 31.3081 187.387V162.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-2_22492_9870",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 77.9873H404.85V98.9873H20.8501V77.9873Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 77.9873H404.85V98.9873H20.8501V77.9873Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.85 98.9873V98.2213H20.8501V98.9873V99.7533H404.85V98.9873Z",
    fill: "#ECECEC",
    mask: "url(#path-19-inside-2_22492_9870)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8501 85.8173C28.8501 83.7021 30.5648 81.9873 32.6801 81.9873H59.0201C61.1353 81.9873 62.8501 83.7021 62.8501 85.8173V91.1573C62.8501 93.2726 61.1353 94.9873 59.0201 94.9873H32.6801C30.5648 94.9873 28.8501 93.2726 28.8501 91.1573V85.8173Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8501 85.8173C72.8501 83.7021 74.5648 81.9873 76.6801 81.9873H103.02C105.135 81.9873 106.85 83.7021 106.85 85.8173V91.1573C106.85 93.2726 105.135 94.9873 103.02 94.9873H76.6801C74.5648 94.9873 72.8501 93.2726 72.8501 91.1573V85.8173Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.85 85.8173C116.85 83.7021 118.565 81.9873 120.68 81.9873H147.02C149.135 81.9873 150.85 83.7021 150.85 85.8173V91.1573C150.85 93.2726 149.135 94.9873 147.02 94.9873H120.68C118.565 94.9873 116.85 93.2726 116.85 91.1573V85.8173Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.85 85.8173C160.85 83.7021 162.565 81.9873 164.68 81.9873H191.02C193.135 81.9873 194.85 83.7021 194.85 85.8173V91.1573C194.85 93.2726 193.135 94.9873 191.02 94.9873H164.68C162.565 94.9873 160.85 93.2726 160.85 91.1573V85.8173Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_22492_9870)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_22492_9870)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_22492_9870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.726 89.2694V91.8746C220.726 92.377 221.135 92.7857 221.637 92.7857H224.22L225.206 93.7718C225.276 93.8416 225.369 93.8788 225.463 93.8788C225.51 93.8788 225.558 93.8697 225.603 93.8509C225.74 93.7943 225.828 93.6622 225.828 93.5142V92.7857H226.375C226.877 92.7857 227.286 92.377 227.286 91.8746V88.5947C227.286 88.0923 226.877 87.6836 226.375 87.6836H224.295M221.091 89.2694V91.8746C221.091 92.176 221.336 92.4213 221.637 92.4213H224.295C224.344 92.4213 224.39 92.4404 224.424 92.4746L225.338 93.2754L225.464 92.6035C225.464 92.5029 225.545 92.4213 225.646 92.4213H226.375C226.676 92.4213 226.921 92.176 226.921 91.8746V88.5947C226.921 88.2933 226.676 88.048 226.375 88.048H224.295",
    stroke: "url(#paint0_linear_22492_9870)",
    strokeWidth: 0.780933
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.381 90.8877L218.381 90.8877C218.458 90.9193 218.538 90.9347 218.617 90.9347C218.777 90.9347 218.934 90.8717 219.052 90.7544L219.052 90.7543L219.052 90.7543L220.248 89.5579H223.436C224.155 89.5579 224.74 88.9732 224.74 88.2542V84.1231C224.74 83.404 224.155 82.8193 223.436 82.8193H217.469C216.75 82.8193 216.166 83.404 216.166 84.1231V88.2542C216.166 88.9732 216.75 89.5579 217.469 89.5579H218.002V90.3193C218.002 90.5688 218.151 90.7921 218.381 90.8877ZM216.937 84.1231C216.937 83.8297 217.176 83.5907 217.469 83.5907H223.436C223.73 83.5907 223.969 83.8297 223.969 84.1231V88.2542C223.969 88.5475 223.73 88.7865 223.436 88.7865H220.088C219.988 88.7865 219.892 88.8256 219.82 88.8954L218.878 89.7204L218.773 89.156C218.764 88.9507 218.595 88.7865 218.387 88.7865H217.469C217.176 88.7865 216.937 88.5475 216.937 88.2542V84.1231Z",
    fill: "#331863",
    stroke: "#331863",
    strokeWidth: 0.312373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.46 87.6765C220.641 87.6765 220.788 87.5297 220.788 87.3485C220.788 87.1674 220.641 87.0205 220.46 87.0205C220.279 87.0205 220.132 87.1674 220.132 87.3485C220.132 87.5297 220.279 87.6765 220.46 87.6765Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.463 86.4233V86.2042C220.947 86.2042 221.34 85.8606 221.34 85.437C221.34 85.0135 220.947 84.6699 220.463 84.6699C219.979 84.6699 219.586 85.0135 219.586 85.437V85.5466",
    stroke: "#331863",
    strokeWidth: 0.702839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.819 90.0264H222.373C222.251 90.0264 222.151 90.126 222.151 90.2489V90.6941C222.151 90.817 222.251 90.9166 222.373 90.9166H222.819C222.941 90.9166 223.041 90.817 223.041 90.6941V90.2489C223.041 90.126 222.941 90.0264 222.819 90.0264Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.239 90.0264H223.794C223.671 90.0264 223.572 90.126 223.572 90.2489V90.6941C223.572 90.817 223.671 90.9166 223.794 90.9166H224.239C224.362 90.9166 224.462 90.817 224.462 90.6941V90.2489C224.462 90.126 224.362 90.0264 224.239 90.0264Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.659 90.0264H225.214C225.091 90.0264 224.992 90.126 224.992 90.2489V90.6941C224.992 90.817 225.091 90.9166 225.214 90.9166H225.659C225.782 90.9166 225.882 90.817 225.882 90.6941V90.2489C225.882 90.126 225.782 90.0264 225.659 90.0264Z",
    fill: "#331863"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 2,
    transform: "translate(204.85 95.9873)",
    fill: "#CEDFFB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22492_9870",
    x: 0.000102997,
    y: -0.000385284,
    width: 415.921,
    height: 281.871,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.38947,
    dy: -4.38947
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.23026
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.317647 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22492_9870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22492_9870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22492_9870",
    x1: 229.254,
    y1: 88.0511,
    x2: 222.058,
    y2: 92.8581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#018384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#009191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CCCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22492_9870"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 30.8496C20.8501 25.3268 25.3273 20.8496 30.8501 20.8496H403.85V269.8H20.8501V30.8496Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22492_9870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4312,
    height: 16.4312,
    fill: "white",
    transform: "translate(381.631 54.4219)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_22492_9870"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.85 85.8173C204.85 83.7021 206.565 81.9873 208.68 81.9873H235.02C237.135 81.9873 238.85 83.7021 238.85 85.8173V91.1573C238.85 93.2726 237.135 94.9873 235.02 94.9873H208.68C206.565 94.9873 204.85 93.2726 204.85 91.1573V85.8173Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_22492_9870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.8105,
    height: 11.8105,
    fill: "white",
    transform: "translate(215.945 82.582)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_22492_9870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.8684,
    height: 11.8568,
    fill: "white",
    transform: "translate(215.916 82.5586)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Img);
export default __webpack_public_path__ + "static/media/step_2_img.f67d48691577e968325c010df8e9570d.svg";
export { ForwardRef as ReactComponent };